
import { ValidationObserver } from 'vee-validate'
import { Component } from 'vue-property-decorator'
import { StringUtils } from '@/commons/utils/string'
import { Country } from '@/commons/constants/classifier'
import { applicantStore, classifiersStore } from '@/store'
import { ClassifiersUtils } from '@/commons/utils/classifiers'
import { ProviderInstance } from 'vee-validate/dist/types/types'
import InputWithLabel from '@/commons/components/core/InputWithLabel.vue'
import TextareaWithLabel from '@/commons/components/core/TextareaWithLabel.vue'
import { translateValidationError } from '@/commons/configuration/vee.validate'
import PersonContactsEstonianAddress from './PersonContactsEstonianAddress.vue'
import RadioButtonRounded from '@/commons/components/core/RadioButtonRounded.vue'
import ClassifierSelectWithLabel from '@/commons/components/core/ClassifierSelectWithLabel.vue'

import {
    validatorIds,
    ContactValidationFieldName
} from '@/commons/constants/application'
import {
    Classifier,
    ValidationError,
    ApplicationContactAddress
} from '@/commons/types'

@Component({
    components: {
        RadioButtonRounded,
        InputWithLabel,
        ClassifierSelectWithLabel,
        PersonContactsEstonianAddress,
        TextareaWithLabel
    }
})
export default class PersonContactsForeignAddress extends ValidationObserver {
    domValidatorIds = validatorIds
    countryValidatorId = ContactValidationFieldName.ADDRESS_COUNTRY
    stateOrProvinceOrCountyValidatorId = ContactValidationFieldName.ADDRESS_STATE_OR_PROVINCE_OR_COUNTY
    cityValidatorId = ContactValidationFieldName.ADDRESS_CITY
    streetValidatorId = ContactValidationFieldName.ADDRESS_STREET
    postalCodeValidationId = ContactValidationFieldName.ADDRESS_POSTAL_CODE
    addressNotesValidationId = ContactValidationFieldName.ADDRESS_NOTES

    excludedClassifiers: Array<string> = [
        Country.ESTONIA
    ]

    get address (): ApplicationContactAddress {
        return applicantStore.applicationContact.address
    }

    composeAddress (): void {
        this.address.fullAddress = StringUtils.composeAddress([
            ClassifiersUtils.translateByCode(this.countryOptions, this.address.country),
            this.address.stateOrProvinceOrCounty,
            this.address.city,
            this.address.street,
            this.address.postalCode
        ])
    }

    setCountry (value: string): void {
        this.address.country = value || null
        this.composeAddress()
    }

    setStateOrProvinceOrCounty (value: string): void {
        this.address.stateOrProvinceOrCounty = value || null
    }

    setCity (value: string): void {
        this.address.city = value || null
    }

    setStreet (value: string): void {
        this.address.street = value || null
    }

    setPostalCode (value: string): void {
        this.address.postalCode = value || null
    }

    get countryOptions (): Array<Classifier> {
        return classifiersStore.countries
    }

    async validateCountry (): Promise<void> {
        const validationProvider = this.$refs.countryValidationProvider as ProviderInstance
        await validationProvider.validate()
    }

    translateError (validationError: ValidationError): string {
        return translateValidationError(validationError)
    }

    setAddressNotes (notes: string): void {
        this.address.notes = notes
    }
}
